
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as g9jFcHOLnJsOxyBNKPGYbh0ZqGu1M_lbyfE0VXDgoaa0Meta } from "/codebuild/output/src1603523745/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexoVuULAZbBUvz5ysK4W_6bWgIoz_ExXw3G014Tz_45jRGoMeta } from "/codebuild/output/src1603523745/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchBl_45g0How_45sPCrx95WcPKtAPhzqBnpyFg_91mwk_45uvHoMeta } from "/codebuild/output/src1603523745/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexXGNVFdVHKR1TxroHxDM1eAmBBjs6Z_jJoBTmxt9BZIkMeta } from "/codebuild/output/src1603523745/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93gKNUBc_45AGB1dmJCUoIzl8cJ_45NVik88kJ1vE0onAlK8MMeta } from "/codebuild/output/src1603523745/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexa0gGhGgzw2khw3ReFffri4NCNbNYwAsh_450Vpu4Ys3gIMeta } from "/codebuild/output/src1603523745/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_938NsAXcaglZQjJK_NXT7nqiwj12LuBkpFcufhk2JEMcYMeta } from "/codebuild/output/src1603523745/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as index8mqnGFibSuNFcrgmjinlyXOwIZOSkXWwq_45ncrPlc6R8Meta } from "/codebuild/output/src1603523745/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93dR8I107W0reGyq6W0WTU36s25s0xOiA2fNbUT9UrS5IMeta } from "/codebuild/output/src1603523745/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexBHilb11_Ek0sj0I2jESdCbi5X_PXm89SIt3Vzrv30uEMeta } from "/codebuild/output/src1603523745/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexdmlnarhhJly_ySHRfhZEUCcMBGBJ05_45_45F1CxH_t3UpoMeta } from "/codebuild/output/src1603523745/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src1603523745/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src1603523745/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src1603523745/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src1603523745/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src1603523745/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexa0gGhGgzw2khw3ReFffri4NCNbNYwAsh_450Vpu4Ys3gIMeta || {},
    component: () => import("/codebuild/output/src1603523745/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src1603523745/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: index8mqnGFibSuNFcrgmjinlyXOwIZOSkXWwq_45ncrPlc6R8Meta || {},
    component: () => import("/codebuild/output/src1603523745/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src1603523745/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexBHilb11_Ek0sj0I2jESdCbi5X_PXm89SIt3Vzrv30uEMeta || {},
    component: () => import("/codebuild/output/src1603523745/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexdmlnarhhJly_ySHRfhZEUCcMBGBJ05_45_45F1CxH_t3UpoMeta || {},
    component: () => import("/codebuild/output/src1603523745/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]